<template>
  <div ref="container" class="plv-ia-timer-countdown">
    <div class="plv-ia-timer-countdown-header">
      <div v-show="showClose" class="plv-ia-timer-countdown__close" @click="handleClose">
        <span class="plv-ia-timer-countdown__close-icon"></span>
      </div>
    </div>

    <div class="plv-ia-timer-countdown-content">
      <p class="plv-ia-timer-countdown-text">  {{ t('plvIA.timer.timer') }}</p>
      <p class="plv-ia-timer-countdown-time">{{ timeArr[0] }}{{ timeArr[1] }}:{{ timeArr[2] }}{{ timeArr[3] }}</p>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
import commonMixin from '../app-mixin';
import timer from '@/mixins/timer';
export default {
  name: 'TimerCountdown',
  mixins: [Locale, commonMixin, timer],
  props: {
    showClose: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    timeArr() {
      let time = this.remainingTime;
      if (!time || time === 0) {
        return [0, 0, 0, 0];
      }
      if (time < 0) {
        time = -time;
      }
      const arr = [];
      const minutes = Math.floor(time / 60);
      const seconds = time % 60;
      arr.push(Math.floor(minutes / 10));
      arr.push(minutes % 10);
      arr.push(Math.floor(seconds / 10));
      arr.push(seconds % 10);
      return arr;
    },
  }
};
</script>

<style lang="scss">
.plv-ia-timer-countdown {
  width: 64px;
  background: rgb(0, 0, 0, .5);
  border-radius: 5px;
  .plv-ia-timer-countdown-header {
    position: relative;
    height: 16px;
  }
  .plv-ia-timer-countdown__close {
    height: 25px;
    width: 25px;
    position: absolute;
    right: 0;
    top: 0;
    text-align: right;
  }
  .plv-ia-timer-countdown__close-icon {
    display: inline-block;
    height: 16px;
    width: 16px;
    background-size: 100% 100%;
    background-image: url(./imgs/icon-close-normal.png);
  }

  .plv-ia-timer-countdown-text {
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    text-align: center;
    margin-top: 2px;
  }
  .plv-ia-timer-countdown-time {
    margin-top: 7px;
    text-align: center;
    font-size: 16px;
    color: #FFFFFF;
    padding: 0 10px 13px;
  }
}

</style>
